import "chartjs-plugin-datalabels";

//import CardHeader from "./CardHeader";
import CardHeader from "@material-ui/core/CardHeader";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import React from "react";
import Chip from "@material-ui/core/Chip";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => {
  return {
    root: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(2),
      paddingTop: "60px",
      position: "relative",
      paddingBottom: (props) => (props.bottom ? `${props.bottom}px` : "20px"),
      [theme.breakpoints.down("xs")]: {
        padding: 0,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingTop: (props) => (props.icono === undefined ? "60px" : "14px"),
      },
      [theme.breakpoints.down("sm")]: {
        paddingBottom: (props) => (props.expand ? "20px" : "20px"),
      },
    },
    withIcon: {
      paddingTop: "14px",
    },
    title: {
      fontWeight: "500",
      letterSpacing: "-0.48px",
      fontSize: "1.5rem",
      color: "#212121",
    },
    subheader: {
      fontSize: "1rem",
      lineHeight: "30px",
      letterSpacing: "-0.32px",
    },
    avatar: {},
    content: {
      marginBottom: "20px",
    },
    chip:{
      backgroundColor: '#D9D9D9 !important',
      color: "#000000 !important",
      height: '20px !important',
    },
    contentHeader: {
      paddingLeft: 0,
      paddingTop: 0,
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "start",
      },
    },
    contentContainer: {
      height: (props) => (props.height ? `65vh` : "-webkit-fill-available"),
      [theme.breakpoints.down("md")]: {
        height: (props) =>
          props.height ? `${props.height}vh` : "-webkit-fill-available",
      },
      [theme.breakpoints.down("sm")]: {
        height: (props) => (props.height ? `${props.height}vh` : "auto"),
        paddingLeft: 0,
        paddingRight: 0,
      },
      [theme.breakpoints.down("xs")]: {
        overflowX: "scroll",
        overflowY: "hidden",
      },
    },
  };
});

const ChartCard = (props) => {
  const classes = useStyles(props);
  const { year } = props;
  return (
    <Card className={classes.root}>
      <Chip className={classes.chip} label={year} />

      <CardHeader
        avatar={props.icono}
        className={classes.contentHeader}
        classes={{
          title: classes.title,
          subheader: classes.subheader,
          avatar: classes.avatar,
        }}
        title={props.title}
        subheader={props.subheader}
      />
      <CardContent className={classes.contentContainer}>
        {props.children}
      </CardContent>
    </Card>
  );
};

export default ChartCard;
